var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-6 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13416",
    "data-name": "Path 13416",
    d: "M18,18h1v6H18Z",
    transform: "translate(-8 -10)",
    fill: "#eb0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13417",
    "data-name": "Path 13417",
    d: "M27,18h1v6H27Z",
    transform: "translate(-14 -10)",
    fill: "#eb0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13418",
    "data-name": "Path 13418",
    d: "M6,9v1H7V20a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V10h1V9ZM8,20V10h8V20Z",
    transform: "translate(0 -4)",
    fill: "#eb0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13419",
    "data-name": "Path 13419",
    d: "M18,3h4V4H18Z",
    transform: "translate(-8)",
    fill: "#eb0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2b95019a2efeaf5f5b233c125be3330e.svg";
export { ForwardRef as ReactComponent };